/** @file The context names to consult for a key event, most specific first. */
import { keyState } from './keyState';

/** The pushed contexts newest first, then `global`, each once. */
export function activeContexts(): string[] {
  const pushed = [...keyState.contexts].reverse().map((c) => c.name);
  return [...new Set([...pushed, 'global'])];
}
